export default "__VITE_ASSET__DIuMrexI__"